import { createAction } from "@reduxjs/toolkit";
import { AddressModel } from "src/components/core/AddressForm/utils";

export const failCountryValidation = createAction(
  "checkoutPhysicalAddress/failCountryValidation"
);
export const failStateValidation = createAction(
  "checkoutPhysicalAddress/failStateValidation"
);
export const userAcceptedSuggestedAddress = createAction<{
  suggestedAddress: Partial<AddressModel>;
  isSameAsBillingAddress: boolean;
}>("checkoutPhysicalAddress/userAcceptedSuggestedAddress");

export const suggestAddress = createAction<Partial<AddressModel>>(
  "checkoutPhysicalAddress/suggestAddress"
);

export const returnedInvalidAddress = createAction(
  "checkoutPhysicalAddress/returnedInvalidAddress"
);
